module.exports = __webpack_public_path__ + "img/ContactUsImage2.539e0e08.png";